import Vue from 'vue'
import appHelper from "./appHelper"

/**
 * 新版 调用app原生方法
 *
 * ```js
 *  appCall("callPhone" , ['13012341234'])
 *      .notApp()       //非app内
 *      .notSupport()   //app内，但不支持此方法
 * ```
 * @param {string} name
 * @param {string[]} params
 * @return NativeCall
 */
export default function appCall( name , params ) {

    if ( Object.prototype.toString.call(params) !== "[object Array]" ) {
        params = [];
    }
    try {
        if (window.webkit && window.webkit.messageHandlers) {
            var handlers = window.webkit.messageHandlers;
            if (handlers[name]) {
                if (params.length === 0) {
                    params.push("0");
                }
                var ret = handlers[name].postMessage(params);   //return a Promise if succeed
            } else {
                return new NativeCall(true);
            }
        } else if ( typeof TYSNAV != 'undefined') {
            TYSNAV[name].apply(TYSNAV, params);
        } else {
            return new NativeCall(true);
        }
        return new NativeCall(false);
    } catch (e) {
        return new NativeCall(true);
    }
}

class NativeCall{

    constructor( callFailed ) {
        var ua = navigator.userAgent;
        this.info = {
            isWeChat : false,
            isInApp : false,
            callFailed : callFailed,
            appVersion : 0,
            appPlatform : ''
        };
        if ( ua.indexOf("MicroMessenger") > -1) {
            this.info.isWeChat = true;
        }
        var reg = new RegExp("AIYUKEAPP@([a-zA-Z]+)@([0-9\.]+)");
        var match = ua.match(reg);
        if (match) {
            var matched = match[0].split("@");
            this.info.appVersion = parseFloat(matched[2]);
            this.info.appPlatform = match[1];
            this.info.isInApp = true;
        }
        console.log(this.info);
    }
    /**
     * @param {function({
            isWeChat : false,
            isInApp : false,
            callFailed : callFailed,
            appVersion : 0,
            appPlatform : ''
        })} callback
     * @return this
     */
    notApp(callback){
        if ( this.info.callFailed && ! this.info.isInApp ){
            callback(this.info);
        }
        return this;
    }
    /**
     * @param  {function({
            isWeChat : false,
            isInApp : false,
            callFailed : callFailed,
            appVersion : 0,
            appPlatform : ''
        })}  callback
     * @return this
     */
    notSupport(callback){
        if ( ! this.info.callFailed ){
            return this;
        }
        if ( this.info.isInApp && this.info.callFailed){
            callback( this.info );
        }
        return this;
    }
}




// WEBPACK FOOTER //
// ./src/lib/AppCall.js